import * as jose from 'jose';
import Auth from '@aws-amplify/auth';
import Lambda from 'aws-sdk/clients/lambda';
import { Amplify } from 'aws-amplify';
import { Buffer } from 'buffer';
import * as GlobalConstants from '../data/GlobalConstants.js';
const AWS = require('aws-sdk');

Amplify.configure({
    Auth: {
        mandatorySignIn: false,
        region: GlobalConstants.AWS_REGION_NAME,
        userPoolId: GlobalConstants.AWS_USER_POOL_ID,
        userPoolWebClientId: GlobalConstants.AWS_USER_POOL_WEB_CLIENT_ID,
        identityPoolId: GlobalConstants.AWS_IDENTITY_POOL_ID,
    },
});

AWS.config.region = GlobalConstants.AWS_REGION_NAME;

const ValidationService = {
    signJWT: async function (member) {
        console.log('Signing JWT for member:', member);
        console.log(JSON.stringify(member));
        const jweArray = await Auth.currentCredentials().then((credentials) => {
            const lambda = new Lambda({
                credentials: Auth.essentialCredentials(credentials),
            });

            const jweArray = readData();

            async function readData() {
                const params = {
                    FunctionName: GlobalConstants.LAMBDA_GETSECRET_NAME,
                    InvocationType: GlobalConstants.LAMBDA_INVOCATION_TYPE,
                    Payload: JSON.stringify({
                            'filter': {
                                "key": "description",
                                "value": "KeyRes"
            }
        })
                };

                const lambdaInvokeResp = await lambda.invoke(params).promise();
                const response = JSON.parse(lambdaInvokeResp.Payload);

                const jweArray =[];
                for ( var key of response) {
                    const id = key.Id;
                    const privateKeyEncoded = key.privateKey.PrivateKey;
                    const privateSecret = Buffer.from(
                        privateKeyEncoded,
                        'base64'
                    ).toString();

                    const publicKeyEncoded = key.publicKey.PublicKey;
                    const publicSecret = Buffer.from(
                        publicKeyEncoded,
                        'base64'
                    ).toString();

                    const alg = 'RS512';
                    let payload = {
                        id: member.pk_id,
                        name: member.name,
                        first_name: member.first_name,
                        last_name: member.last_name,
                        email: member.email,
                        type: member.type,
                        id_betis: member.id_betis,
                        id_tipo: member.id_tipo,
                        birthdate: member.birthdate,
                        mobile_phone: member.mobile_phone
                    };

                    const privateKey = await jose.importPKCS8(privateSecret, alg);

                    let expirationTime = '2h'; // Valor por defecto: 2 horas
                    if (GlobalConstants.REACT_APP_JWT_EXPIRATION_TIME) {
                        const expTimeNumber = parseInt(GlobalConstants.REACT_APP_JWT_EXPIRATION_TIME, 10);
                        if (!isNaN(expTimeNumber)) {
                            expirationTime = `${expTimeNumber}h`;
                        }
                    }

                    const jwt = await new jose.SignJWT(payload)
                        .setProtectedHeader({ alg })
                        .setJti('SSOBetis')
                        .setIssuedAt()
                        .setExpirationTime(expirationTime)
                        .sign(privateKey);

                    const encode = TextEncoder.prototype.encode.bind(new TextEncoder());
                    const publicKey = await jose.importSPKI(publicSecret, 'RSA-OAEP-256');
                    const jwe = await new jose.CompactEncrypt(encode(jwt))
                        .setProtectedHeader({ alg: 'RSA-OAEP-256', enc: 'A256GCM' })
                        .encrypt(publicKey)
                        jweArray.push({Id: id, JWE: jwe});
                        //console.log(jweArray);
                }
                return jweArray;
            }
            return jweArray;
        });
        return jweArray;
    },

    verifyJWT: async function (jwt) {
        const verify = Auth.currentCredentials().then((credentials) => {
            const lambda = new Lambda({
                credentials: Auth.essentialCredentials(credentials),
            });

            const verify = readData();

            async function readData() {
                const params = {
                    FunctionName: GlobalConstants.LAMBDA_GETSECRET_NAME,
                    InvocationType: GlobalConstants.LAMBDA_INVOCATION_TYPE,
                    Payload: JSON.stringify({
                            'filter': {
                                "key": "description",
                                "value": "KeyReq"
            }
        })
                };

                const lambdaInvokeResp = await lambda.invoke(params).promise();
                const response = JSON.parse(lambdaInvokeResp.Payload);

                const publicKeyEncoded = response[0].publicKey.PublicKey;
                const publicSecret = Buffer.from(
                    publicKeyEncoded,
                    'base64'
                ).toString();
                const alg = 'RS512';

                try {
                    const publicKey = await jose.importSPKI(publicSecret, alg);

                    const { payload, protectedHeader } = await jose.jwtVerify(
                        jwt,
                        publicKey
                    );
                    return { payload: payload, header: protectedHeader };
                } catch (e) {
                    throw new Error(e);
                }
            }
            return verify;
        });
        return verify;
    },

    main: async function () {
        Auth.signIn('UsuarioTest_001', 'Nubika123!')
        .then(async (user) => {
            const result = await Auth.updateUserAttributes(user, {
                challengeName: 'CONFIRMED',
            });
            //console.log(result); // SUCCESS
        })
        .catch((e) => {
            console.log(e);
        });

    },
};

export { ValidationService };
